// extracted by mini-css-extract-plugin
export default {"activeSidebar":"ha-z","pageLayout":"ia-z","mainContent":"ja-z","columnLayout":"ka-z","columnLayoutFill":"la-z","columnLayoutLast":"ma-z"};